import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { routerMiddleware } from "connected-react-router";
import rootSaga from "./sagas";
import { rootReducer } from "./reducers";
import { composeWithDevTools } from "redux-devtools-extension";

const createCustomStore = (history) => {
  const sagaMiddleware = createSagaMiddleware();

  const middleware = [
    routerMiddleware(history),
    sagaMiddleware,
  ];

  const store = createStore(
    rootReducer(history),
    {},
    process.env.NODE_ENV === "development"
      ? composeWithDevTools(applyMiddleware(...middleware))
      : applyMiddleware(...middleware),
  );

  const sagas = sagaMiddleware.run(rootSaga, store.dispatch, store.getState)
    .toPromise();

  return {
    store,
    sagas,
  };
};

export default createCustomStore;
